import { axiosInstanceB2B, getHeaders } from '@share/utils';

export const GetCreditLineByAccountId = (accountId: string) =>
  axiosInstanceB2B.get(`/identity/creditline/ByAccountId/${accountId}`, {
    ...getHeaders(),
  });
